import { getRouteApi } from '@tanstack/react-router';
import { CurrencyInput } from 'cpool-components/input/CurrencyInput';
import type { LOAN_REQUEST_COMMAND } from 'cpool-constants';
import type { ParseKeys } from 'i18next';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormField';
import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import type { SchemaExpensesForm } from '~/features/leadDetails/schemas/expenses.schema.ts';
import { canExecuteApplicantCommand } from '~/features/leadDetails/utils/aclPermissions';

type Keys = keyof SchemaExpensesForm;

type Props = {
    name: `${Keys}.${number}.betragMonatlich`;
    label?: ParseKeys<'de'>;
    isSecondApplicant?: boolean;
    commandName: LOAN_REQUEST_COMMAND;
};

export const ExpenseField: React.FC<Props> = ({ commandName, isSecondApplicant, label = 'AMOUNT', name }) => {
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const { control } = useFormContext<SchemaExpensesForm>();
    const { t } = useTranslation();

    return (
        <FormField<SchemaExpensesForm, number | null> control={control} name={name}>
            {({ error, onChange, value }) => (
                <CurrencyInput
                    id={name}
                    label={t(label)}
                    labelClassName="h-8 w-[230px] shrink-0 justify-start"
                    // [&>div] is the field column next to the label: without min-w-0 it keeps the
                    // intrinsic width of the euro suffix and the row overflows on narrow screens
                    className="w-full min-w-0 [&>div]:min-w-0"
                    value={value}
                    onChange={onChange}
                    min={0}
                    disabled={
                        !canExecuteApplicantCommand({ applicant: isSecondApplicant ? 2 : 1, commandName, permissions })
                    }
                    error={error}
                />
            )}
        </FormField>
    );
};
